import get from 'lodash.get';

/**
 * Determines if an albumFolder has been purchased by a member/account/user.
 *
 * @param {Account|Identity|Member} member Object containing purchased_album_folders.
 * @param {AlbumFolder} albumFolder The album folder to check if purchased.
 */
const hasPurchasedAlbumFolder = (member, albumFolder) => {
  if (!albumFolder) {
    return false;
  }

  return get(member, 'purchased_album_folders.records', []).some(
    ({ id }) => id === albumFolder.id,
  );
};

/**
 * Returns a filtered list of identiites that should be displayed for Tag Selection.
 *
 * @param {Object} opts List of options.
 * @param {Array<Identities>} opts.identities List of identities to filter.
 * @param {Array<SubscribedItem>} opts.subscribedAlbumFolderIdentities List of Subscribed Album Folder identities.
 * @param {AlbumFolder} opts.albumFolder The album folder being tested.
 * @param {Array<Identities>} opts.identitiesForPurchase List of identities ready to checkout but not purchased.
 *
 */
const getIdentitiesForTagSelection = ({
  identities = [],
  subscribedAlbumFolderIdentities = [],
  albumFolder,
  identitiesForPurchase = [],
}) => {
  const identitiesForPurchaseIds = identitiesForPurchase.map(
    identity => identity.id,
  );

  return identities.filter(identity => {
    // TODO: As pointed out in the PR #1125, it'd be better to implement
    // a flag in GQL to avoid requesting all of this different info.
    const identityHasPurchasedAlbumFolder = get(
      identity,
      'purchased_album_folders.records',
      [],
    ).some(
      purchasedAlbumFolder =>
        purchasedAlbumFolder.id === get(albumFolder, 'root.id', albumFolder.id),
    );

    const isIdentitySubscribedToAlbumFolder =
      subscribedAlbumFolderIdentities.some(
        subscribedItem => get(subscribedItem, 'identity.id') === identity.id,
      );

    const isIdentityJoinedToAlbumFolderAlbum =
      // Support for Album folders that are *not* JOIN ALL.
      get(identity, 'album_memberships.records', []).some(
        membership =>
          get(membership, 'album.root_album_folder.id') ===
          get(albumFolder, 'root.id', albumFolder.id),
      );

    // Support for albums that require tags before checkout
    const isIdentityForPurchase = identitiesForPurchaseIds.includes(
      identity.id,
    );

    return (
      identityHasPurchasedAlbumFolder ||
      isIdentitySubscribedToAlbumFolder ||
      isIdentityJoinedToAlbumFolderAlbum ||
      isIdentityForPurchase
    );
  });
};

export { hasPurchasedAlbumFolder, getIdentitiesForTagSelection };
